import { FC, ReactNode, useEffect } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';

const Block = styled.div`
  width: 100vw;

  .box {
    width: 1200px;
    margin: 10px auto;
    border: 1px solid black;
  }
`;

interface IProps {
  title: string;
  isBoxOff?: boolean;
  children: ReactNode;
}

const NewWindowLayout: FC<IProps> = ({
  title,
  isBoxOff = false,
  children,
}) => {
  useEffect(() => {
    // document.body.style.width = '100vw';
    document.body.style.backgroundColor = 'white';
    // const content = document.querySelector('div.content');
    // if (content) content.classList.add('w-100vw');
    const navbar = document.querySelector('nav.main-header');
    if (navbar) navbar.classList.add('d-none');
    const sidebar = document.querySelector('div.main-sidebar');
    if (sidebar) sidebar.classList.add('d-none');
  }, []);

  return (
    <Block>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={isBoxOff ? '' : 'box'}>
        {children}
      </div>
    </Block>
  );
}

export default NewWindowLayout;
